<template>
  <div id="app">
    <masthead></masthead>
    <navigation></navigation>
    <router-view></router-view>
    <site-footer></site-footer>
  </div>
</template>

<script>
import Masthead from './components/layouts/Masthead'
import Navigation from './components/layouts/Navigation'
import SiteFooter from './components/layouts/SiteFooter'

export default {
  name: 'app',
  components: {
    Masthead,
    Navigation,
    SiteFooter
  }
}
</script>

<style lang='scss'>
@import '~assets/styles/main';

#app {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  > main {
    flex: 1;
    opacity: 1;
    transition: 200ms opacity;
    &.loading {
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?5384e10f